import axios from 'axios';

const api = axios.create({
  //baseURL: 'http://localhost:3001', // Development-URL
  baseURL: 'https://admin-api.regulaid.de', // Production
  withCredentials: true,            // ⬅️ wichtig für Cookies
  validateStatus: () => true
});

export default api;